export const ROUTES = {
  ROOT: '/',

  AUTH: {
    ROOT: '/auth',
    LOGIN: '/auth/login',
    FORGOT_PASSWORD: '/auth/forgot-password',
    VERIFY_ACCOUNT: '/auth/verify-account',
  },

  SYSTEM: {
    ABOUT: '/system/about',
  },

  DASHBOARD: {
    ROOT: '/dashboard',
  },

  ORGANIZATIONS: {
    ROOT: '/organizations',
    DETAIL: '/organizations/:organizationKey',
  },

  ACCOUNTS: {
    ROOT: '/accounts',
    DETAIL: '/accounts/:accountKey',
  },

  ROLE_ASSIGNMENTS: {
    ROOT: '/role-assignments',
  },

  STUDIES: {
    ROOT: '/studies',
    DETAIL: '/studies/:studyKey',
  },

  SITES: {
    ROOT: '/sites',
    DETAIL: '/sites/:siteKey',
  },

  SUBJECTS: {
    ROOT: '/subjects',
    DETAIL: '/subjects/:subjectKey',
  },

  SENSORS: {
    ROOT: '/sensors',
    DETAIL: '/sensors/:sensorKey',
  },
} as const;
